import React, { useEffect, useState, useContext } from 'react';
import { Context } from 'app/AppContext';
import { AxiosResponse } from 'axios';
import axios from 'utils/axios';

import { Container, NumberPad, Iamport } from 'components';
import {
  Wrapper, Header, HeaderTitle, HeaderDescription,
  Section, Title, Content, Item, Button,
  ShopItem, ShopItemHeader, ShopItemCell, ShopItemBody,
  SectionContent, Radio, Required,
} from './style';

interface Props {
  location: any,
  history: any,
  match: any,
}

interface Response {
  ceo_name: string,
  ceo_email: string,
  ceo_tel: string,
  ceo_shop_item_title: string,
  price: number,
}

const Pay: React.FC<Props> = props => {
  const [isOpen, setOpen] = useState<boolean>(false);
  const [manager, setManager] = useState<string>('-');
  const [shopItem, setShopItem] = useState<string>('-');
  const [price, setPrice] = useState<number>(0);
  const [name, setName] = useState<string>('');
  const [email, setEmail] = useState<string>('');
  const [phone, setPhone] = useState<string>('');
  const [payMethod] = useState<string>('card');
  const [password, setPassword] = useState<string>('');
  const [passwordLoading, setPasswordLoading] = useState<boolean>(false);
  const [isPaid, setPaid] = useState<boolean>(false);
  const context = useContext(Context);

  useEffect(() => {
    const uid = props.match.params.uid;
    if (!uid) {
      alert('올바른 결제정보가 아닙니다. 다시 확인해주세요.');
      props.history.push('/');
    } else {
      axios.get(`/ceo/payment/${uid}/`)
        .then((res: AxiosResponse) => {
          const data = res.data;
          setShopItem(data.ceo_shop_item_title);
          setPrice(data.price);
          setManager(data.salesman_name);
        }).catch(err => {
          if (!err.status) {
            alert('서버에 문제가 발생했습니다. 나중에 다시 시도해주세요.');
            props.history.push('/');
          }
        })
    }
    // eslint-disable-next-line
  }, [props.match.params.uid]);

  useEffect(() => {
    if (password.length > 3) {
      const uid = props.match.params.uid;
      if (uid) {
        setPasswordLoading(true);
        axios.post(`/ceo/payment/${uid}/password/`, {
          password,
        }).then((res: AxiosResponse) => {
          axios.post(`/ceo/order/${uid}/init/`, {
            buyer_email: email,
            buyer_name: name,
            buyer_tel: phone,
          }).then((res: AxiosResponse) => {
            setPaid(true);
          }).catch(err => {
            setPaid(false);
            context.setMessage('문제가 발생했습니다. 나중에 다시 시도해주세요.', 'warning');
          })
        }).catch(err => {
          const res = err.response;
          if (!res.status) {
            context.setMessage('인터넷 연결을 확인해주세요', 'error');
          } else if (res.status === 400) {
            setPassword('');
            context.setMessage('결제번호를 확인해주세요', 'error');
          } 
        }).finally(() => {
          setPasswordLoading(false);
        })
      }
    }
    // eslint-disable-next-line
  }, [password]);

  const _handleOpen = (isOpen: boolean = true) => {
    if (!name) {
      context.setMessage('이름을 입력해주세요', 'error');
    } else if (!email) {
      context.setMessage('이메일을 입력해주세요', 'error');
    } else if (!phone) {
      context.setMessage('휴대전화를 입력해주세요', 'error');
    } else {
      setOpen(isOpen);
    }
  }

  const _handlePassword = (password: string) => {
    setPassword(password);
  }

  const onPaySuccess = (rsp: any) => {
    const uid = props.match.params.uid;
    props.history.push(`/pay/${uid}/complete`);
  }

  const onPayFail = (rsp: any) => {
    context.setMessage('결제가 실패했습니다. 다시 시도해주세요', 'warning');
  }

  const onPayComplete = (rsp: any) => {
    setOpen(false);
  }

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
    }}>
      <Header>
        <Container>
          <HeaderTitle>주문서</HeaderTitle>
          <HeaderDescription>주문하실 상품명 및 가격을 정확하게 확인해 주세요.</HeaderDescription>
        </Container>
      </Header>

      <Container>
        <Wrapper>  
          <Section>
            <Title>상품 정보</Title>
            <Content>
              <ShopItem>
                <ShopItemHeader>
                  <ShopItemCell>상품 정보</ShopItemCell>
                  <ShopItemCell>상품 금액</ShopItemCell>
                </ShopItemHeader>
                <ShopItemBody>
                  <ShopItemCell>{shopItem}</ShopItemCell>
                  <ShopItemCell>{price!.toLocaleString()}원</ShopItemCell>
                </ShopItemBody>
              </ShopItem>
            </Content>
          </Section>
          <Section>
            <Title>주문자 정보</Title>
            <SectionContent>
              <Item>
                <p>공급자</p>
                <span>데이트팝</span>
              </Item>
              <Item>
                <p>담당 매니저</p>
                <span>{manager}</span>
              </Item>
              <Item>
                <Required>*</Required>
                <p>사장님 이름</p>
                <input
                  type="text"
                  value={name}
                  onChange={e => setName(e.target.value)}
                />
              </Item>
              <Item>
                <Required>*</Required>
                <p>사장님 이메일</p>
                <input
                  type="email"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                />
              </Item>
              <Item>
                <Required>*</Required>
                <p>사장님 휴대전화</p>
                <input
                  type="tel"
                  placeholder="- 없이 입력해주세요"
                  onChange={(e) => setPhone(e.target.value.replace(/[^0-9]/, ''))}
                  value={phone}
                />
              </Item>
            </SectionContent>
          </Section>

          <Section>
            <Title>결제 수단</Title>
            <Item>
              <p>일반 결제</p>
              <Radio>
                <input type="radio" defaultChecked={true} value={payMethod} />
                <span></span>
                카드 결제
              </Radio>
            </Item>
          </Section>

          <Button onClick={() => _handleOpen()}>결제하기</Button>
        </Wrapper>
      </Container>

      <NumberPad
        isOpen={isOpen}
        isLoading={passwordLoading}
        password={password}
        _handleOpen={_handleOpen}
        _handlePassword={_handlePassword}
      />

      <Iamport
        params={{
          pay_method: payMethod,
          name: shopItem,
          amount: price,
          buyer_email: email,
          buyer_name: name,
          buyer_tel: phone,
          m_redirect_url: ''
        }}
        isPaid={isPaid}
        onSuccess={(rsp) => onPaySuccess(rsp)}
        onFailed={(rsp) => onPayFail(rsp)}
        onCompleted={(rsp) => onPayComplete(rsp)}
      />
    </div> 
  );
};

export default Pay;
